import * as React from "react";
const SvgImport24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "black",
        viewBox: "0 0 22 22"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M1 0H0v22h17v-7h-2v5H2V2h13v5h2V0H1Zm8.9 5.785.716-.7 1.398 1.43-.715.7L8.452 10H22v2H8.452l2.847 2.785.715.7-1.398 1.43-.715-.7-4.6-4.5L4.57 11l.73-.715 4.6-4.5Z",
      clipRule: "evenodd"
    })
  );
export default SvgImport24Px;
